<template>
  <v-layout column>
    <h3 class="font-weight-medium mb-4">
      Scoreboard
      <span class="body-2">(Top 10 in your grade)</span>
    </h3>
    <p
      class="caption cus-bg"
      v-if="!searchListed"
    >Note: Your account is not yet active to be displayed on scoreboard. It may take upto 24 hours for it to change.</p>

    <v-layout v-if="!isScoreboardFetched" column justify-center align-center class="mt-5">
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      <p class="subheading-1 mt-5 primary--text font-weight-bold">Retrieving Scoreboard...</p>
    </v-layout>

    <v-simple-table v-else class="mt-3">
      <thead>
        <tr>
          <th class="text-left">
            <v-icon class="mr-2" small>mdi-account</v-icon>Name
          </th>
          <th class="text-left">
            <v-icon class="mr-2" small>mdi-school</v-icon>School name
          </th>
          <th class="text-left">
            <v-icon class="mr-2" small>mdi-checkbox-blank-circle</v-icon>Points
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in getScoreboard" :key="item.url">
          <td>{{ item.fullName }}</td>
          <td>{{ item.schoolName }}</td>
          <td>{{ item.points }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-layout>
</template>

<style scoped>
.br {
  border-radius: 3px;
}

.cus-bg {
  color: rgb(219, 161, 0);
  display: inline-block;
  padding: 10px;
  background-color: rgba(253, 243, 182, 0.5);
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["isScoreboardFetched", "getScoreboard", "searchListed"])
  },
  methods: {
    ...mapActions(["fetchScoreboard"])
  },
  created() {
    if (!this.isScoreboardFetched) {
      this.fetchScoreboard();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isScoreboardFetched) return;
    return next();
  }
};
</script>